// Bot images
import dynamoImg from 'assets/img/hodlie/botCategory/dynamo.png';
import grizzlyImg from 'assets/img/hodlie/botCategory/grizzly.png';
import deepScalperImg from 'assets/img/hodlie/botCategory/deep.png';
import centImg from 'assets/img/hodlie/botCategory/pixelCent.png';
import generalImg from 'assets/img/hodlie/botCategory/noBot.png';

export const botMedia = {
  takeProfitBot30: {
    img: deepScalperImg,
    anim: () =>
      fetch('/img/animated-icons/DeepScalper.json').then(response =>
        response.json()
      )
  }, // Deep Scalper
  iBot30: {
    img: dynamoImg,
    anim: () =>
      fetch('/img/animated-icons/Dynamo.json').then(response => response.json())
  }, // Dynamo
  iBot60: {
    img: grizzlyImg,
    anim: () =>
      fetch('/img/animated-icons/Grizzly.json').then(response =>
        response.json()
      )
  }, // Grizzly
  takeProfitBot60: {
    img: centImg,
    anim: () =>
      fetch('/img/animated-icons/Centurion.json').then(response =>
        response.json()
      )
  }, // Centurion
  6: {
    anim: () =>
      fetch('/img/animated-icons/BT.json').then(response => response.json())
  }, // Market Leaders
  7: {
    anim: () =>
      fetch('/img/animated-icons/YT.json').then(response => response.json())
  }, // High Volume
  8: {
    anim: () =>
      fetch('/img/animated-icons/RT.json').then(response => response.json())
  }, // Discovery Altcoins
  general: {
    img: generalImg,
    anim: () =>
      fetch('/img/animated-icons/robot.json').then(response => response.json())
  } // General Bot
};
